// Now we can remove a couple of things here using dynamic_forms component
document.addEventListener("turbolinks:load", function(event) {
  $("#add-type").on("click", function(e) {
    e.preventDefault();
    let vaccineTypesContainer = document.getElementById("types");
    let vaccineTypes = document.querySelectorAll(".types-fields");
    let vaccineTypesSize = vaccineTypes.length;
    let firstVaccineType = vaccineTypes[0];
    let clone = firstVaccineType.cloneNode(true);

    // This will waranty cloned nodes are enabled for edition
    clone.classList.remove("discarded-type");
    clone.classList.remove("opacity-25");

    // This replaces the `discard` name when the first node is disabled
    clone.querySelector(`label[for^='${classPrefix}']`).innerHTML = "Name" 
    // This hides the day required input, which depends on the booster radio buttons
    for (input of clone.querySelectorAll('.days-required')) {
      input.classList.add('hidden');
    }

    // This block updates the icon of the clone (whether is a restore or delete icon)
    const deleteBtn = clone.querySelector('.delete-type-btn');
    deleteBtn.innerHTML = timesIcon
    deleteBtn.classList.remove('discarded-delete-btn')
    deleteBtn.classList.remove('bg-green-500');
    deleteBtn.classList.remove('hover:bg-green-600');
    deleteBtn.classList.add('bg-red-500');
    deleteBtn.classList.add('hover:bg-red-600');

    const cloneInputs = clone.querySelectorAll('input')
    for(cloneInput of cloneInputs) {
      // If not a radio, clear the value.
      if (cloneInput.type !== 'radio') cloneInput.setAttribute("value", "");
      // If the input is the field, we reset the default value to 365.
      if (cloneInput.classList.contains('days-required')) cloneInput.setAttribute("value", "365");
      // In case the node we are based on is disabled, we remove the constraint.
      cloneInput.removeAttribute("readonly");
    }

    const radioButtonsContainer = clone.querySelector('.radio-buttons');
    const radioButtons = radioButtonsContainer.querySelectorAll('input[type="radio"]');
    for (radioButton of radioButtons) {
      radioButton.checked = false;
      // For a brief amount of time, the radio btns have the same name!
      // Thus when appending it, it unchecks the parent radio button.
      let newName = radioButton.name.replace(/\d/, vaccineTypesSize)
      radioButton.setAttribute("name", newName);
      radioButton.classList.remove("invisible");
    }

    vaccineTypesContainer.append(clone);
    // TODO: Let's refactor how the attribute assignation and event listeners occurs.
    updateVaccinationTypeAttributes();
    showOrHideDeleteBtns();
    setDeleteTypeEventListener();
    setBoostersEventListener(clone);
  });

  // Update vaccine type id when page is loaded
  updateVaccineTypeContainerId();

  function updateVaccineTypeContainerId() {
    let vaccineTypeNumber = 0;

    for(vaccineType of document.querySelectorAll('.types-fields')) {
      setVaccineTypeId(vaccineType, vaccineTypeNumber);

      vaccineTypeNumber += 1;
    }
  }

  // On page load: Event listener for boosters radio to show days required field
  for (radioButton of document.querySelectorAll('.booster-radio')) {
    const vaccineTypeId = radioButton.name.match(/\d+/)[0];
    const daysRequiredInputId = document.querySelector(`#${classPrefix}${vaccineTypeId}_days_required`);
    radioButton.addEventListener("change", function () {
      toggleDaysRequired(this, daysRequiredInputId);
    })
  }

  // Show or hide delete btns when page is loaded, depending in the number of present vaccine types
  showOrHideDeleteBtns();

  // update vaccine type number when page is reloaded
  updateItemNumber();

  function updateVaccinationTypeAttributes() {
    let vaccinatinTypes = document.querySelectorAll('.types-fields');
    let vaccineTypeNumber = 0;

    for(vaccineType of vaccinatinTypes) {
      for(child of vaccineType.children) {
        updateItemNumber();
        setInputAttributes(child, vaccineTypeNumber);
        setLabelAttributes(child, vaccineTypeNumber);
        setDeleteBtnAttributes(child, vaccineTypeNumber);
      }
      setVaccineTypeId(vaccineType, vaccineTypeNumber)
      vaccineTypeNumber += 1;
    }
  }

  function setVaccineTypeId(vaccineType, vaccineTypeNumber) {
    vaccineType.id = `vaccine-type-${vaccineTypeNumber}`;
  }

  function setDeleteTypeEventListener() {
    let vaccineTypeNumber = document.querySelectorAll('.types-fields').length - 1;
    let id = `delete-btn-${vaccineTypeNumber}`;
    let deleteBtn = document.getElementById(id);
    let vaccineTypeId = `vaccine-type-${vaccineTypeNumber}`;

    let vaccineTypeMainContainer = document.getElementById(vaccineTypeId);

    deleteBtn.addEventListener("click", function() {
      vaccineTypeMainContainer.remove();
      updateItemNumber();
      showOrHideDeleteBtns();
    });
  }

  // This is for new clones
  function setBoostersEventListener(clonedNode) {
    const vaccineTypeId = clonedNode.id.match(/\d+/)[0];
    const daysRequiredInputId = document.querySelector(`#${classPrefix}${vaccineTypeId}_days_required`);
    for (radioButton of clonedNode.querySelectorAll('.booster-radio')) {
      radioButton.addEventListener("change", function () {
        toggleDaysRequired(this, daysRequiredInputId);
      })
    }
  }

  function setDeleteBtnAttributes(child, vaccineTypeNumber) {
    let buttons = child.getElementsByTagName('button');

    for(btn of buttons) {
      btn.id = `delete-btn-${vaccineTypeNumber}`;
    }
  }

  function setLabelAttributes(child, vaccineTypeNumber) {
    let labelFields = child.getElementsByTagName('label');

    for(label of labelFields){
      let attrFor = label.htmlFor.split(/\d_/).pop();

      label.htmlFor = `${classPrefix}${vaccineTypeNumber}_${attrFor}`;
    }
  }

  function setInputAttributes(child, vaccineTypeNumber) {
    let inputFields = child.getElementsByTagName('input');

    for(input of inputFields) {
      setInputName(input, vaccineTypeNumber);
      setInputId(input, vaccineTypeNumber);
    }
  }

  function setInputName(input, vaccineTypeNumber) {
    let attrName = input.name.replaceAll("[", " ").replaceAll("]", "").split(" ").pop();

    input.name = `vaccine[vaccine_types_attributes][${vaccineTypeNumber}][${attrName}]`;
  }

  function setInputId(input, vaccineTypeNumber) {
    let inputId = input.id.split(/\d_/).pop();

    input.id = `${classPrefix}${vaccineTypeNumber}_${inputId}`;
  }

  function toggleDaysRequired(radioButton, daysRequired) {
    if(radioButton.value === 'required' ) {
      daysRequired.classList.remove('hidden');
      daysRequired.nextElementSibling.classList.remove('hidden');
    } else {
      daysRequired.classList.add('hidden');
      daysRequired.nextElementSibling.classList.add('hidden');
    }
  }

  addDeleteBtnsListeners()
});

const classPrefix = "vaccine_vaccine_types_attributes_"
const timesIcon = "<span class='font-bold text-2xl'>&times;</span>"
const restoreIcon = `<svg fill="currentColor", width=14 height=35 viewbox="0 0 35 35" xmlns="http://www.w3.org/2000/svg"}>
                      <path d="m30.7291339 9.79155047c-.8469032-1.97227172-1.9858242-3.67374923-3.4162518-5.10417683-1.4306833-1.43042759-3.1319051-2.56909295-5.1044326-3.41650751-1.9722717-.84741456-4.0414565-1.27086613-6.2080659-1.27086613-2.0415685 0-4.0171644.38509545-5.9270435 1.15605347-1.90962339.77095803-3.607521 1.85771478-5.09369282 3.26052596l-2.70870923-2.68774122c-.41680318-.43061138-.89574327-.52778022-1.4375874-.29176222-.55565234.2362737-.83335065.64617277-.83335065 1.22944151v9.3333227c0 .3610589.13194506.6735335.39583517.9374236.26414581.2638901.57662034.3958351.93767929.3958351h9.33332264c.5835245 0 .9931679-.2776983 1.2291858-.8333506.236018-.5415884.1388492-1.0207842-.2917622-1.4375874l-2.85420676-2.8749191c.97245551-.91671129 2.08350446-1.62144108 3.33340256-2.11470079 1.2501538-.493004 2.5555405-.73976171 3.9166714-.73976171 1.4444915 0 2.8230104.28153393 4.1355569.84383465 1.3125464.56255644 2.4476319 1.32303046 3.4060235 2.28142206.9583916.95813589 1.7188656 2.09347709 2.281422 3.40602349.5623008 1.3125465.843579 2.6908097.843579 4.1355569s-.2812782 2.8227548-.843579 4.1353013c-.5625564 1.3125464-1.3230304 2.4478876-2.281422 3.4062792s-2.0937328 1.7188656-3.4060235 2.2811663c-1.3125465.5625565-2.6913212.8438347-4.1355569.8438347-1.6528931 0-3.2152658-.361059-4.6876294-1.0831769-1.47210791-.7221179-2.71510192-1.7429021-3.72898204-3.0626084-.09716884-.1388491-.25698601-.2224655-.4791958-.2503376-.20840159 0-.38202696.0623927-.52087612.1874336l-2.85420679 2.8751748c-.11097704.1114885-.17004547.2534061-.17694957.4270315-.0069041.1738811.03835612.3298626.13552496.4687118 1.51404394 1.8334225 3.34721079 3.2536218 5.50001199 4.2603421 2.15280117 1.0067204 4.42373927 1.5104641 6.81255847 1.5104641 2.1666094 0 4.2360499-.4237073 6.2083216-1.2708662 1.9722718-.8471588 3.6732379-1.9863356 5.1041769-3.4165075 1.4304276-1.430939 2.5690929-3.1319051 3.4165075-5.1041768.8471588-1.9722717 1.2706104-4.041968 1.2706104-6.2083217 0-2.1668651-.4237073-4.2355385-1.2708661-6.20781023z" />
                    </svg>`

function updateItemNumber() {
  let count = 0;
  document.querySelectorAll('.item-count').forEach((e) => {
    e.innerText = count += 1;
  })
}

function showOrHideDeleteBtns() {
  const totalTypes = document.querySelectorAll('.types-fields')
  const totalTypesToDiscard = document.querySelectorAll('.discarded-type')
  // This is triggered when only one vaccine type remains
  if (totalTypesToDiscard.length === (totalTypes.length - 1)) {
    const lastDeleteBtn = document.querySelector(".delete-type-btn:not(.discarded-delete-btn)")
    lastDeleteBtn.classList.add('hidden');
  } else {
    for (btn of document.querySelectorAll('.delete-type-btn')) {
      btn.classList.remove('hidden');
    }
  }
}

function addDeleteBtnsListeners() {
  for (deleteBtn of document.querySelectorAll('.delete-type-btn')) {
    deleteBtn.addEventListener("click", function () {
      if (!this.classList.contains('discarded-delete-btn')) {
        const confirmationDialog = confirm("Warning: You are disabling a vaccine type. This will prevent the type from being used in the future. Existing vaccination records will still refer to this vaccine type.")
        if (!confirmationDialog) return;
      }

      updateActionButton(this)
      const vaccineTypeContainer = this.parentElement.parentElement;
      const id = vaccineTypeContainer.id.split("-").pop();
      vaccineTypeContainer.classList.toggle("discarded-type");

      const discarded = document.getElementById(`${classPrefix}${id}_discarded_at`)
      if (discarded != null) discarded.value = (discarded.value === "" ? new Date().toISOString() : "");

      // This makes it look deactivated
      vaccineTypeContainer.classList.toggle('opacity-25');
      // This actually makes it read only
      toggleChildrenLock(id)
      updateItemNumber();
      showOrHideDeleteBtns();
    })
  }
}

function toggleChildrenLock(id) {
  const nameLabel = document.querySelector(`label[for='${classPrefix}${id}_name']`)
  nameLabel.innerHTML = nameLabel.innerHTML == "Name" ? "DEACTIVATED" : "Name";
  const children = [
    document.getElementById(`${classPrefix}${id}_name`),
    document.getElementById(`${classPrefix}${id}_number_of_doses`),
    document.getElementById(`${classPrefix}${id}_days_valid`),
    document.getElementById(`${classPrefix}${id}_waiting_period`),
    document.getElementById(`${classPrefix}${id}_boosters_not_required`),
    document.getElementById(`${classPrefix}${id}_boosters_optional`),
    document.getElementById(`${classPrefix}${id}_boosters_required`),
    document.getElementById(`${classPrefix}${id}_days_required`),
  ]
  children.forEach((child) => {
    child.toggleAttribute("readonly")
    if (child.type == "radio") child.classList.toggle("invisible")
  })
}

function updateActionButton(btn) {
  // This class is used to count non-discarded elements
  btn.classList.toggle('discarded-delete-btn');
  btn.classList.toggle('bg-green-500');
  btn.classList.toggle('hover:bg-green-600');
  btn.classList.toggle('bg-red-500');
  btn.classList.toggle('hover:bg-red-600');

  btn.innerHTML = btn.classList.contains('discarded-delete-btn') ? restoreIcon : timesIcon
}
